import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoProvidersIllusration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 372,
	height: 366,
	viewBox: "0 0 372 366",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M184.25 365.462C275.577 365.462 349.612 291.427 349.612 200.099C349.612 108.772 275.577 34.7366 184.25 34.7366C92.9224 34.7366 18.887 108.772 18.887 200.099C18.887 291.427 92.9224 365.462 184.25 365.462Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M348.503 199.876C353.196 199.876 357 196.071 357 191.378C357 186.686 353.196 182.881 348.503 182.881C343.811 182.881 340.006 186.686 340.006 191.378C340.006 196.071 343.811 199.876 348.503 199.876Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.915 15.0661C127.849 15.0661 131.039 11.8769 131.039 7.94279C131.039 4.00869 127.849 0.819473 123.915 0.819473C119.981 0.819473 116.792 4.00869 116.792 7.94279C116.792 11.8769 119.981 15.0661 123.915 15.0661Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.12332 256.719C11.0574 256.719 14.2466 253.53 14.2466 249.596C14.2466 245.662 11.0574 242.473 7.12332 242.473C3.18922 242.473 0 245.662 0 249.596C0 253.53 3.18922 256.719 7.12332 256.719Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M359.28 97.5643C366.305 97.5643 372 91.8692 372 84.8441C372 77.8189 366.305 72.1239 359.28 72.1239C352.255 72.1239 346.56 77.8189 346.56 84.8441C346.56 91.8692 352.255 97.5643 359.28 97.5643Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M293.176 113.897H77.1457C69.699 113.897 63.6623 119.934 63.6623 127.38V291.084C63.6623 298.531 69.699 304.568 77.1457 304.568H293.176C300.622 304.568 306.659 298.531 306.659 291.084V127.38C306.659 119.934 300.622 113.897 293.176 113.897Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M293.186 117.967C298.375 117.967 302.588 122.191 302.588 127.37V291.084C302.588 296.274 298.365 300.487 293.186 300.487H77.1355C71.9456 300.487 67.7327 296.264 67.7327 291.084V127.38C67.7327 122.191 71.9558 117.978 77.1355 117.978H293.175M293.186 109.827H77.1355C67.4477 109.827 59.5917 117.683 59.5917 127.37V291.084C59.5917 300.772 67.4477 308.628 77.1355 308.628H293.175C302.863 308.628 310.719 300.772 310.719 291.084V127.38C310.719 117.693 302.863 109.837 293.175 109.837L293.186 109.827Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M327.754 286.047H223.041C221.525 286.047 220.192 287.034 219.744 288.49L217.984 294.28C217.587 295.572 216.396 296.458 215.053 296.458H153.457C152.103 296.458 150.913 295.572 150.526 294.28L148.765 288.49C148.328 287.034 146.985 286.047 145.468 286.047H40.7556C36.3493 286.047 32.7774 289.619 32.7774 294.025V305.168C32.7774 309.575 36.3493 313.146 40.7556 313.146H327.744C332.15 313.146 335.722 309.575 335.722 305.168V294.025C335.722 289.619 332.15 286.047 327.744 286.047H327.754Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M254.353 71.7067H114.166C102.926 71.7067 93.814 80.8187 93.814 92.059V226.975C93.814 238.215 102.926 247.327 114.166 247.327H254.353C265.593 247.327 274.706 238.215 274.706 226.975V92.059C274.706 80.8187 265.593 71.7067 254.353 71.7067Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.166 71.7067H254.353C265.588 71.7067 274.706 80.8245 274.706 92.059V100.485H93.814V92.059C93.814 80.8245 102.932 71.7067 114.166 71.7067Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.707 65.6925V78.4331",
			stroke: "#9EC5FF",
			strokeWidth: 14.3123,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.803 65.6925V78.4331",
			stroke: "#9EC5FF",
			strokeWidth: 14.3123,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.34 162.366H124.007C121.511 162.366 119.489 164.389 119.489 166.884V179.218C119.489 181.713 121.511 183.736 124.007 183.736H136.34C138.836 183.736 140.858 181.713 140.858 179.218V166.884C140.858 164.389 138.836 162.366 136.34 162.366Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.395 162.366H160.061C157.566 162.366 155.543 164.389 155.543 166.884V179.218C155.543 181.713 157.566 183.736 160.061 183.736H172.395C174.89 183.736 176.913 181.713 176.913 179.218V166.884C176.913 164.389 174.89 162.366 172.395 162.366Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.449 162.366H196.115C193.62 162.366 191.597 164.389 191.597 166.884V179.218C191.597 181.713 193.62 183.736 196.115 183.736H208.449C210.944 183.736 212.967 181.713 212.967 179.218V166.884C212.967 164.389 210.944 162.366 208.449 162.366Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.34 201.799H124.007C121.511 201.799 119.489 203.822 119.489 206.317V218.651C119.489 221.146 121.511 223.169 124.007 223.169H136.34C138.836 223.169 140.858 221.146 140.858 218.651V206.317C140.858 203.822 138.836 201.799 136.34 201.799Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.395 201.799H160.061C157.566 201.799 155.543 203.822 155.543 206.317V218.651C155.543 221.146 157.566 223.169 160.061 223.169H172.395C174.89 223.169 176.913 221.146 176.913 218.651V206.317C176.913 203.822 174.89 201.799 172.395 201.799Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.449 201.799H196.115C193.62 201.799 191.597 203.822 191.597 206.317V218.651C191.597 221.146 193.62 223.169 196.115 223.169H208.449C210.944 223.169 212.967 221.146 212.967 218.651V206.317C212.967 203.822 210.944 201.799 208.449 201.799Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.395 123.208H160.061C157.566 123.208 155.543 125.231 155.543 127.726V140.06C155.543 142.555 157.566 144.578 160.061 144.578H172.395C174.89 144.578 176.913 142.555 176.913 140.06V127.726C176.913 125.231 174.89 123.208 172.395 123.208Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.449 123.208H196.115C193.62 123.208 191.597 125.231 191.597 127.726V140.06C191.597 142.555 193.62 144.578 196.115 144.578H208.449C210.944 144.578 212.967 142.555 212.967 140.06V127.726C212.967 125.231 210.944 123.208 208.449 123.208Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.492 123.208H232.159C229.664 123.208 227.641 125.231 227.641 127.726V140.06C227.641 142.555 229.664 144.578 232.159 144.578H244.492C246.988 144.578 249.011 142.555 249.011 140.06V127.726C249.011 125.231 246.988 123.208 244.492 123.208Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M249.967 218.864C272.133 218.864 290.102 200.895 290.102 178.729C290.102 156.564 272.133 138.595 249.967 138.595C227.802 138.595 209.833 156.564 209.833 178.729C209.833 200.895 227.802 218.864 249.967 218.864Z",
			fill: "#FFC700"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.167 210.459L208.113 210.774C205.467 210.815 203.737 208.006 204.958 205.655L214.717 186.992L229.167 210.448V210.459Z",
			fill: "#FFC700"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248.685 162.153H251.25C259.36 162.153 265.934 168.736 265.934 176.837V185.792H233.991V176.837C233.991 168.726 240.575 162.153 248.675 162.153H248.685Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265.598 183.614H234.347C232.756 183.614 231.467 184.901 231.467 186.489C231.467 188.076 232.756 189.364 234.347 189.364H265.598C267.188 189.364 268.478 188.076 268.478 186.489C268.478 184.901 267.188 183.614 265.598 183.614Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M249.967 199.509C254.038 199.509 257.437 196.609 258.2 192.773H241.725C242.498 196.619 245.887 199.509 249.957 199.509H249.967Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M249.683 158.753C251.158 158.753 252.349 159.954 252.349 161.42V163.689H247.016V161.42C247.016 159.944 248.217 158.753 249.683 158.753Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.288 176.898C237.054 176.664 236.932 176.338 236.962 175.992C237.166 174.038 237.797 172.196 238.824 170.507C239.7 169.072 240.819 167.841 242.152 166.854C242.651 166.487 243.343 166.589 243.719 167.078C244.085 167.576 243.984 168.278 243.495 168.645C242.386 169.469 241.46 170.487 240.738 171.677C239.883 173.082 239.364 174.608 239.191 176.226C239.13 176.837 238.58 177.284 237.959 177.223C237.695 177.193 237.461 177.081 237.288 176.898Z",
			fill: "#FFC700"
		})
	]
});
export default SvgNoProvidersIllusration;
